import { queryOptions } from "@tanstack/react-query";
import { Share } from "@/lib/capacitor/Share";

export const queryOptions_canShare = () =>
	queryOptions({
		queryKey: ["@capacitor/share", "canShare"] as const,
		queryFn: () => Share.canShare(),
		initialData: false,
	});
